<template>
    <div>
    <card-dashboard 
        id="card-faturamento"
        bg-variante="danger" 
        icone="fa-solid fa-file-invoice-dollar" 
        titulo="" 
        :valor="valor"
        titulo-modal="Faturamento"
        :colunas="colunas"
        :dados="dados"
        monetario
    >
        <template #cabecalho>
            <h6 class="text-center text-white mt-2 mb-1 text-uppercase">
                <slot name="titulo">
                    Faturamento
                </slot>
            </h6>
        </template>
        <template #valor>
            <div class="row mb-0">
                <div class="col-12 text-center border-bottom border-white">
                    <b-badge variant="light">NF à faturar</b-badge>
                    <div class="font-weight-bold text-center font-size-14 mb-1 text-white">
                        {{faturar}}
                    </div>
                </div>
                <div class="col-12 text-center border-top border-white">
                    <b-badge variant="light" class="mt-1">NF faturadas</b-badge>
                    <div class="font-weight-bold text-center font-size-14  text-white">
                        {{faturadas}}
                    </div>
                </div>
            </div>
        </template>
    </card-dashboard>
    </div>
</template>
<script>
import CardDashboard from "@/components/card/CardDashboard";
import DashboardExecutoraService from "@/common/services/dashboards/dashboard_executora.service";
import helpers from "@/common/utils/helpers";
export default {
    components : {
        CardDashboard
    },
    mounted(){
        this.buscarDados();
    },
    data : () => ({
        valor : 0,
        colunas : [
            { key : "projeto",  label : "Código do projeto"},
            { key : "notasFiscaisAFaturar",  label : "Notas fiscais à faturar",
                formatter(value){
                    return helpers.formatarValor(value);
                }
            },
            { key : "notasFiscaisFaturadas", label : "Notas fiscais faturadas",
                formatter(value){
                    return helpers.formatarValor(value);
                }}
        ],
        dados : [],
    }),
    methods : {
        buscarDados(){
            DashboardExecutoraService.faturamento(this.empresasSelecionada).then(response => {
                this.dados = response.data.data;
            });
        },
    },
    computed : {
        empresasSelecionada : function(){
            if(!this.$store.state.app.selectedCompanyObj)
                return null;
            return this.$store.state.app.selectedCompanyObj.id;  
        },
        faturar : function(){
            return helpers.formatarValor(this.dados.reduce((total, item) => {
                return total + item.notasFiscaisAFaturar;
            }, 0));
        },
        faturadas : function(){
            return helpers.formatarValor(this.dados.reduce((total, item) => {
                return total + item.notasFiscaisFaturadas;
            }, 0));
        }
    }
    
}
</script>
<style lang="">
    
</style>